export enum VERSION_TYPE {
	VERSION = 'version',
	BUILDNUMBER = 'buildNumber',
}
const version = {
	get version() {
		return localStorage.getItem(VERSION_TYPE.VERSION);
	},

	get buildNumber() {
		return localStorage.getItem(VERSION_TYPE.BUILDNUMBER);
	},

	between: (target: VERSION_TYPE, start: number, end: number) => {
		const v = localStorage.getItem(target);
		return !!window.ReactNativeWebView && (!v || (parseInt(v) >= start && parseInt(v) <= end));
	},

	over: (target: VERSION_TYPE, value: number) => {
		const v = localStorage.getItem(target);
		return !!window.ReactNativeWebView && (!v || parseInt(v) >= value);
	},
};

export default version;
